<template>
  <div class="container-login">
    <div class="container-dados">
      <div class="container">
        <div class="row justify-content-center align-items-center">
          <div class="col-md-6 col-lg-5 text-center d-none d-md-block">
            <div class="logo-lecard"><img src="../assets/logo-light.png" alt="Logo LeCard"></div>
          </div>
          <div class="col-md-6 col-lg-5">
            <div class="card shadow-sm border mx-auto" style="max-width: 360px">
              <div class="card-body">
                <div class="mb-4"><img src="../assets/logo-lecard.png" alt="Logo LeCard" style="width: 32px;"></div>
                <div v-if="step === 3">
                  <auth2 @voltar="voltar" @auth="logar" :telefone="telefone" :error="error" :load="load"/>
                </div>
                <div v-else>
                  <h5 class="mb-1">Login</h5>
                  <div class="mb-3">
                    <div class="mb-0" v-if="step === 1">Informe seu usuário de acesso</div>
                    <div class="mb-0" v-else>{{dados.email}} <a href="javascript:" class="small text-primary" @click="voltar(1)">(Alterar)</a></div>
                  </div>
                  <div>
                    <form @submit.prevent="logar()">
                      <div v-if="error" class="alert-error small">{{ error }}</div>
                      <div class="form-group" v-if="step === 1">
                        <input type="email" id="usuario" v-model="dados.email" class="form-control" placeholder="Usuário ou email" minlength="4" :disabled="load" required>
                      </div>
                      <div class="form-group input-senha" v-else>
                        <input :type="showPassword ? 'text' : 'password'" id="inputSenha" class="form-control" v-model="dados.senha" placeholder="Digite sua senha" autocomplete="password" :disabled="load" required>
                        <i class="fa" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'" @click="mostrarSenha()" v-show="dados.senha.length > 0"
                           :title="showPassword ? 'Esconder senha' : 'Mostrar senha'"></i>
                      </div>
                      <button class="btn btn-primary btn-block py-2" :disabled="load">{{load ? 'Aguarde' : 'Continuar'}}</button>
                      <div class="text-center mt-4 mb-3">
                        <p class="mb-0" v-if="step === 1"><a class="text-primary" href="https://lecard.tawk.help/article/como-encontrar-meu-usuario" target="_blank">Não sei meu usuário</a></p>
                        <a href="javascript:" class="text-primary text-decoration-none" @click="recuperarSenha()" v-else>Esqueceu a senha?</a>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-botton text-white">
      <div class="container pb-3 text-center">
        <p class="m-0 small">Uma empresa <a href="https://storkdigital.com.br" class="text-white font-weight-bold" target="_blank">Agência Stork</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../components/commons/Loading";
import Auth2 from "@/components/commons/Auth2";
export default {
  name: 'Login',
  components: {Auth2, Loading},
  data() {
    return {
      load: false,
      showPassword: false,
      step: 1,
      telefone: '',
      error: '',
      dados: {
        pin: '',
        email: '',
        senha: ''
      }
    }
  },

  methods: {
    async logar(pin) {
      this.dados.pin = "";

      switch (this.step) {
        case 1:
          this.dados.senha = "";
          break;

        case 3:
          this.dados.pin = pin || "";
          break;
      }

      this.error = "";
      this.load = true;

      const server = await this.resolveServer(false);

      if (!server.server_available) {
        this.load = false;
        this.error = "Não foi possível conectar. Por favor verifique sua conexão com a internet e tente novamente.";
        return;
      }

      const login_base_server = server.base_server;

      this.$http.post(login_base_server + 'auth/v2/login', this.dados)
        .then(res => {
          const data = res.data || {};

          if (!data.success || !['1','2','3'].includes(data.id_funcao)) {
            this.error = "Este usuário não tem acesso nesta plataforma!";
            this.load = false;
            return;
          }

          if (data.token) {
            localStorage.setItem("key", data.token);
            localStorage.setItem("email", this.dados.email);
            window.location.reload();

          } else if (data.sem_senha) {
            sessionStorage.setItem('sem_senha', this.dados.email)
            this.$router.push('/recuperar');

          } else {
            this.load = false;
            this.telefone = data.telefone;

            if (data.step === 2) {
              this.step = 3;

            } else if (this.step === 1) {
              this.step = 2;
              this.$nextTick(() => {
                this.$helpers.focusElement('inputSenha');
              });
            }
          }

        }, res => {
          // console.log(res);
          this.load = false;

          if (!res.status) {
            this.error = "Não foi possível conectar. Por favor verifique sua conexão com a internet e tente novamente.";

          } else {
            const data = res.data || {};
            this.error = data.msg ? data.msg : 'Erro temporário';

            if (res.status === 401) {
              this.$helpers.focusElement(this.step === 3 ? 'validar_cod_pin' : (this.step === 1 ? 'usuario' : 'inputSenha'));
            }
          }
        });
    },

    voltar() {
      this.step = 1;
      this.dados.pin = "";
      this.error = "";
      this.$nextTick(() => {
        this.$helpers.focusElement('usuario');
      });
    },

    mostrarSenha() {
      this.showPassword = !this.showPassword;
    },

    recuperarSenha() {
      sessionStorage.setItem('recuperar', this.dados.email)
      this.$router.push('/recuperar');
    }
  },

  mounted() {
    if (localStorage.getItem("email")) {
      this.dados.email = localStorage.getItem("email");
      this.$helpers.focusElement('inputSenha');

    } else {
      this.$helpers.focusElement('usuario');
    }
  }
}
</script>

<style scoped>
.container-login {
  background-color: var(--primary);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.container-botton {
  position: absolute;
  width: 100%;
  z-index: 1;
  bottom: 0;
}
.container-dados {
  position: absolute;
  top: 48%;
  transform: translateY(-50%);
  width: 100%;
}
.logo-lecard img {
  width: 300px;
  object-fit: cover;
}

@media (max-width: 767px) {
  .container-dados {
    padding-top: 0;
  }
}

@media (max-height: 550px) {
  .container-login {
    position: static;
  }
  .container-dados {
    position: static;
    transform: none;
    padding: 100px 0 92px;
  }
  .container-botton {
    position: static;
  }
}
</style>
